import { render } from "./units-list-page.vue?vue&type=template&id=6224814e&scoped=true"
import script from "./units-list-page.vue?vue&type=script&lang=js"
export * from "./units-list-page.vue?vue&type=script&lang=js"

import "./units-list-page.vue?vue&type=style&index=0&id=6224814e&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6224814e"]])

export default __exports__